import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { ReactSVG } from 'react-svg';
import { useTheme } from '@forma/forma-ui-theme';
import { Modal, Button } from '@forma/forma-ui-kit';
import ClientWrap from '@/components/ClientWrap';
import Video from '@/components/Video';

import styles from './about-video.module.css';

export const AboutVideo = ({ video, open, onClose, onOpen, showPlaceholder }) => {
  return (
    <div>
      {showPlaceholder && (
        <div className={styles.videoPlacehoder} onClick={onOpen}>
          <img
            src="/images/video_placeholder.svg"
            className={styles.videoPlacehoderImage}
            alt=""
            width="475px"
            height="276px"
          />
          <img
            src="/images/play.svg"
            className={styles.videoPlacehoderPlay}
            alt=""
            width="55px"
            height="55px"
          />
        </div>
      )}
      <ClientWrap>
        <Modal
          open={open}
          onClose={onClose}
          width="1024px"
        >
          <Video
            className={styles.video}
            src={video}
          />
        </Modal>
      </ClientWrap>
    </div>
  );
};

export const AboutVideoLarge = ({ video }) => {
  const { t } = useTranslation();
  const [showVideo, setShowVideo] = useState(false);
  const { viewport } = useTheme();
  const isPhone = viewport === 'phone';

  return (
    <div className={styles.root}>
      <img src={isPhone ? '/images/about_bg_phone.svg' : '/images/about_bg.svg'} className={styles.image} alt="" width="100%" />
      <div className={styles.rootVideo}>
        <AboutVideo
          showPlaceholder={!isPhone}
          video={video}
          open={showVideo}
          onClose={() => setShowVideo(false)}
          onOpen={() => setShowVideo(true)}
        />
      </div>
      {isPhone && (
        <div className={styles.buttons}>
          <Button
            viewStyle="primary"
            icon={<ReactSVG src="/icons/play.svg" wrapper="span" />}
            className={styles.button}
            onClick={() => setShowVideo(true)}
          >
            {t('watch_about_video')}
          </Button>
        </div>
      )}
    </div>
  );
};
